import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Table, Loader, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import TasksTable from '../list/TasksTables';
import './styles.scss';

class TasksCodes extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.WarrantyTasksCodes,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.fetchWarrantyTasksCodesList();
  }

  renderLoaderOrCodes = () => {
    const {loading, list} = this.props;
  
    if (loading) {
      return (
        <Table striped className='toyota-grid'>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan='100%'>
                <Loader active inline='centered' content='Ejecutando' />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return <TasksTable list={list} />;
  };

  render() {
    return (
      <div className="warranty-container">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Códigos Tareas de Garantías</h2>
              <div className="title-bar-actions">
                <Button
                  primary
                  className="toyota-primary"
                  as={Link}
                  to={paths.WarrantyTaskCodeNew}
                >
                  Añadir nuevo
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className="task-codes-warranty-table">
          {this.renderLoaderOrCodes()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'list': state.warrantyTasksCodes.list,
    'loading': state.warrantyTasksCodes.loading,
    'filteredList': state.warrantyTasksCodes.filteredList,
  };
};

const {fetchWarrantyTasksCodesList, navigateTo} = Actions;

const mapDispatchToProps = {
  fetchWarrantyTasksCodesList,
  navigateTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(TasksCodes);
